const o = "Concordo", e = "Celebre", c = "Concluído", n = "Discordo", t = "Engraçado", s = "Oi", a = "Amor", r = "Uau", d = {
  agree: o,
  celebrate: e,
  completed: c,
  disagree: n,
  funny: t,
  hi: s,
  love: a,
  wow: r
};
export {
  o as agree,
  e as celebrate,
  c as completed,
  d as default,
  n as disagree,
  t as funny,
  s as hi,
  a as love,
  r as wow
};
